/**
 * This method returns undefined.
 *
 * @returns {undefined} Always undefined.
 */
const noop = function noop() {}; /* eslint-disable-line lodash/prefer-noop */

export default noop;
